import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import { CommonCollections } from '../../App';
import { useRefereeCollections } from '../../context/RefereeReportCollections';
import { useAdminActionCollections } from '../../context/AdminActionCollections';
import { REFEREE_STATUS } from '../../utils/constants';

const ActionButtons = ({ row }) => {
  const { setRefereeReportId } = useContext(CommonCollections);
  const { setNonAdminRefereeReportId } = useRefereeCollections();

  const { id, refereeStatusId } = row.original;

  const isDraftOrExtension =
    refereeStatusId === REFEREE_STATUS.PENDING ||
    refereeStatusId === REFEREE_STATUS.EXTENSION_APPROVED ||
    refereeStatusId === REFEREE_STATUS.EXTENSION_REQUESTED;
  const buttonIcon = isDraftOrExtension
    ? 'bi bi-pen action-button'
    : 'bi bi-eye view-button';
  const buttonToolTipText = isDraftOrExtension ? 'Edit' : 'View';
  const { enableRefereeReportUploads } = useAdminActionCollections();

  const handleClick = () => {
    setRefereeReportId(id);
    setNonAdminRefereeReportId(id);
  };
  if (!enableRefereeReportUploads) {
    return '';
  }
  return (
    <Link to="/referee-report" onClick={handleClick}>
      <span title={buttonToolTipText}>
        <i className={buttonIcon} />
      </span>
    </Link>
  );
};

ActionButtons.propTypes = {
  row: PropTypes.object,
};

export default ActionButtons;
